import React, { useState, useEffect } from "react";
import AreYouSureModal from "../../../../components/modals/areYouSureModal";
import authServices from "../../../../services/authServices";
import CustomIcon from "../../../../components/customIcon";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import moment from "moment";
import {
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import userServices from "../../../../services/userServices";
import { useSnackbar } from "notistack";
import familymemberServices from "../../../../services/familymemberServices";
import FamilyMemberCreateDLTModel from "./FamilyCreateDLTModel";
import { Tabs, Tab } from "@mui/material";
import { getAccountLink } from '../../../../utils/blockchainExplorer';

const FamilymemberDltWallet = ({ familyMemberId, getallFamilyMember }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dltAccountId, setDltAccountId] = useState();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [primaryOpen, setPrimaryOpen] = useState(false);
  const [availableBlockchainAccounts, setAvailableBlockchainAccounts] =
    useState([]);
  const [blockchainAccountModal, setBlockchainAccountModal] = useState(false);
  // const [familymemberAccount, setfamilymemberAccount] = useState();
  const [familymemberAccount, setFamilyMemberAccount] = useState();
  const [selectedNetwork, setSelectedNetwork] = useState("polygon"); // default network
  const [availablePolygonBlockchainAccounts, setAvailablePolygonBlockchainAccounts] = useState([]);
  const [availableMstBlockchainAccounts, setAvailableMstBlockchainAccounts] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const getFamilyMemberAccount = async () => {
    const res = await familymemberServices.familyMemberById(familyMemberId);
    if (res && res.success) {
      setFamilyMemberAccount(res.data);
    } else {
      enqueueSnackbar("Somthing went wrong", {
        variant: "error",
        autoHideDuration: 4000,
      });
    }
  };

  useEffect(() => {
    getFamilyMemberAccount();
  }, [blockchainAccountModal]);

  useEffect(() => {
    // Set initial selected network based on available accounts
    // Priority: Polygon if available, otherwise Algorand
    if (availablePolygonBlockchainAccounts.length > 0) {
      setSelectedNetwork("polygon");
    } else if (availableBlockchainAccounts.length > 0) {
      setSelectedNetwork("algorand");
    } else if (availableMstBlockchainAccounts.length > 0) {
      setSelectedNetwork("mst");
    }
  }, [availablePolygonBlockchainAccounts, availableBlockchainAccounts]);

  const handlePrimary = async () => {
    // const res = await userServices.updatePrimaryDLTAccount({
    //   entityType: "FAMILYMEMBER",
    //   entityId: familyMemberId,
    //   dltWalletId: dltAccountId,
    // });

    let res;
    if(selectedNetwork == 'algorand')
      res = await userServices.updatePrimaryDLTAccount({ entityId: familyMemberId, dltWalletId: dltAccountId, entityType: "FAMILYMEMBER" });
    else if (selectedNetwork === 'polygon')
      res = await userServices.updatePrimaryDLTPolygonAccount({ entityId: familyMemberId, dltWalletId: dltAccountId, entityType: "FAMILYMEMBER" });

    if (res && res.success) {
      getFamilyMemberAccount();
    }
  };

  const handleRemove = async () => {
    // const res = await userServices.removeDLTAccount({
    //   entityType: "FAMILYMEMBER",
    //   entityId: familyMemberId,
    //   dltWalletId: dltAccountId,
    // });

    let res;
    if(selectedNetwork == 'algorand')
      res = await userServices.removeDLTAccount({ entityId: familyMemberId, dltWalletId: dltAccountId, entityType: "FAMILYMEMBER" });
    else if (selectedNetwork === 'polygon')
      res = await userServices.removeDLTPolygonAccount({ entityId: familyMemberId, dltWalletId: dltAccountId, entityType: "FAMILYMEMBER" });
    

    if (res && res.success) {
      getFamilyMemberAccount();
      enqueueSnackbar("DLT Account Deleted Successfully!", {
        variant: "success",
        anchorOrigin: { horizontal: "right", vertical: "top" },
        autoHideDuration: 3000,
      });
    } else
      enqueueSnackbar(
        "This DLT Account is Holding Some Digital Assets. Please Contact RealX Admin!",
        {
          variant: "error",
          anchorOrigin: { horizontal: "center", vertical: "bottom" },
          autoHideDuration: 9000,
        }
      );
  };
  const fetchDltWallet = async () => {
    let dltWallet = await userServices.getDltWallet(familyMemberId);
    setAvailableBlockchainAccounts(dltWallet.data);

    // Polygon wallet (new)
    let network = "polygon";
    let polygonDltWallet = await userServices.getDltWallet(familyMemberId, network);
    setAvailablePolygonBlockchainAccounts(polygonDltWallet.data);
    let mstDltWallet = await userServices.getDltWallet(familyMemberId, "mst");
    setAvailableMstBlockchainAccounts(mstDltWallet.data);
  };

  useEffect(() => {
    fetchDltWallet();
  }, [familymemberAccount]);

  const handleDLTCreationStatus = async (familyMemberId, status) => {
    const res = await familymemberServices.updateFamilyMemberDLTCreationStatus({
      familyMemberId: familyMemberId,
      status,
    });
    if (res && res.success) {
      getFamilyMemberAccount();
    }
  };

  const copyUrl = (account) => {
    navigator.clipboard.writeText(account);
    enqueueSnackbar("Copied to Clickboard", {
      variant: "success",
      anchorOrigin: { horizontal: "right", vertical: "top" },
      autoHideDuration: 800,
    });
  };

  const currentAccounts =
  selectedNetwork === "polygon"
    ? availablePolygonBlockchainAccounts
    : selectedNetwork === "mst"
    ? availableMstBlockchainAccounts
    : availableBlockchainAccounts;

  return (
    <Stack
      spacing={3}
      width={{ md: "100%", xs: "100%", lg: "50%", sm: "100%" }}
    >
      <AreYouSureModal
        open={primaryOpen}
        setOpen={setPrimaryOpen}
        handleYes={handlePrimary}
        message={"Are You Sure About Updating your Primary DLT Account?"}
        publicAddress={availableBlockchainAccounts[currentIndex]?.publicAddress}
        publicAddressMessage={"Your New Primary DLT Account Address"}
      />
      <AreYouSureModal
        open={deleteOpen}
        setOpen={setDeleteOpen}
        handleYes={handleRemove}
        message={"Are You Sure About Permanently Deleting this DLT Account?"}
        note={"This action can not be undo!"}
        publicAddress={availableBlockchainAccounts[currentIndex]?.publicAddress}
        publicAddressMessage={"DLT Account Address To Be Removed"}
      />

      <Typography fontSize={"14px"}>Available Blockchain Accounts</Typography>

      {(availablePolygonBlockchainAccounts?.length > 0 || availableBlockchainAccounts?.length > 0 || availableMstBlockchainAccounts?.length > 0) && (
        <Tabs
          value={selectedNetwork}
          onChange={(e, newValue) => setSelectedNetwork(newValue)}
          centered
        >
          {availablePolygonBlockchainAccounts?.length > 0 && (
            <Tab label="Polygon" value="polygon" />
          )}
          {availableBlockchainAccounts?.length > 0 && (
            <Tab label="Algorand" value="algorand" />
          )}
          {availableMstBlockchainAccounts?.length > 0 && (
            <Tab label="MST" value="mst" />
          )}
        </Tabs>
      )}

      <Stack
        flexDirection={"column"}
        sx={{
          overflowX: { xs: "auto", sm: "auto", md: "hidden" },
          flexWrap: "wrap",
        }}
        gap={2}
      >
        {currentAccounts.length > 0 ? (
          currentAccounts
            .sort((a, b) => (b.isPrimary ? 1 : -1) - (a.isPrimary ? 1 : -1)) // Sort primary account first
            .map((account, index) => {
              return (
                <Stack
                  key={account._id} // Add a key for better React performance
                  flexDirection={"row"}
                  columnGap={{ xs: 1, sm: 2 }}
                  sx={{
                    width:"100%",
                  }}
                >
                  <Stack
                    flexDirection={"row"}
                    sx={{
                      padding: {xs: "0px", sm: "15px"},
                      borderRadius: "10px",
                      boxShadow: "0px 1px 6px 0px #51515129",
                      width: "100%",
                    }}
                  >
                    <Box sx={{ padding: "2px" }} width={"100%"}>
                      <Box
                        sx={{ display: "flex" }}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                        <Typography sx={{ fontSize: {xs: 8, sm: 12, md: 14, lg: 16} }}>
                          #{index + 1}. ...{account.publicAddress?.slice(-25)}
                        </Typography>
                        <Box
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            copyUrl(account.publicAddress);
                          }}
                          sx={{
                            bgcolor: "#f4f6f7",
                            borderRadius: "50%",
                            height: {xs: "10px", sm: "20px"},
                            width: {xs: "10px", sm: "20px"},
                          }}
                        >
                          <CustomIcon
                            name="copy"
                            sx={{
                              bgcolor: "#FFF",
                              backgroundColor: "#333333",
                              cursor: "pointer",
                            }}
                          />
                        </Box>
                        </Box>
                        <Box sx={{ marginLeft: "4px" }}>
                          {account.isPrimary ? (
                            <Typography
                              sx={{
                                color: "white",
                                background: "#21ab37",
                                padding: "2px 15px !important",
                                fontSize: {xs: 8, sm: 10, md: 12, lg: 14},
                                border: "1px solid #21ab37",
                                borderRadius: "10px",
                              }}
                            >
                              Primary Account
                            </Typography>
                          ) : (
                            <Stack
                              flexDirection={"row"}
                              alignItems={"center"}
                              columnGap={{ xs: 1, sm: 2 }}
                              sx={{ m: "0 !important" }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  p: "4px 15px !important",
                                  fontSize: {xs: 8, sm: 10, md: 12, lg: 14},
                                  marginLeft: "5px",
                                }}
                                onClick={() => {
                                  setDltAccountId(account._id);
                                  setCurrentIndex(index);
                                  setPrimaryOpen(true);
                                }}
                              >
                                Make Primary
                              </Button>
                              <RemoveCircleOutlineIcon
                                sx={{ color: "red", cursor: "pointer" }}
                                onClick={() => {
                                  setDltAccountId(account._id);
                                  setCurrentIndex(index);
                                  setDeleteOpen(true);
                                }}
                              />
                            </Stack>
                          )}
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          paddingTop: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: {xs: 10, sm: 12, md: 14, lg: 16},
                            }}
                          >
                            {account?.name?.slice(0, 30)}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: {xs: 10, sm: 12, md: 14, lg: 16} }}>
                            {account?.created_at
                              ? ` Created On: ${moment(
                                  account?.created_at
                                ).format("DD-MM-YYYY")}`
                              : ""}
                          </Typography>
                        </Box>
                      </Box>
                      <Button
                      variant="outlined"
                      size="small"
                      sx={{ fontSize: "12px !important" }}
                      onClick={() => {
                        const explorerUrl = getAccountLink(selectedNetwork , account.publicAddress);
                        window.open(explorerUrl, "_blank");
                      }}
                    >
                      {selectedNetwork === "algorand"
                        ? "View on Pera Explorer"
                        : selectedNetwork === "mst"
                        ? "View on MSTscan"
                        : "View on Polygonscan"}
                    </Button>

                    </Box>
                  </Stack>
                </Stack>
              );
            })
        ) : (
          <Typography variant="subtitle1">
            You have not made any DLT accounts yet
          </Typography>
        )}
      </Stack>

      <Stack flexDirection={"row"} gap={1} justifyContent={"center"}>
        <Button
          onClick={() =>
            familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "APPROVED"
              ? setBlockchainAccountModal(true)
              : handleDLTCreationStatus(familymemberAccount?._id, "PENDING")
          }
          variant="contained"
          sx={{ width: "max-content", py: "10px !important" }}
          disabled={
            (availableBlockchainAccounts?.length +
              availablePolygonBlockchainAccounts?.length +
              availableMstBlockchainAccounts?.length >= 5 ) ||
            familymemberAccount?.walletInfo?.isAllowedToCreateDLT ==
              "PENDING" ||
            familymemberAccount?.status != "APPROVED"
          }
        >
          {familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "APPROVED"
            ? "Create a New DLT Account"
            : familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "PENDING"
            ? "Request Submitted to RealX Admin"
            : "Request to Create a New DLT Account"}
        </Button>

        {familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "PENDING" && (
          <Button
            variant="contained"
            sx={{ py: "7px !important" }}
            onClick={() =>
              handleDLTCreationStatus(familymemberAccount?._id, "CREATED")
            }
          >
            Cancel Request
          </Button>
        )}
      </Stack>
      {blockchainAccountModal && (
        <FamilyMemberCreateDLTModel
          open={blockchainAccountModal}
          setOpen={setBlockchainAccountModal}
          familymemberAccount={familymemberAccount}
          getallFamilyMember={() => getallFamilyMember()}
          disableAlgorandOption = {availableBlockchainAccounts.length >=2}
          disablePolygonOption = {availablePolygonBlockchainAccounts.length >= 5}
        />
      )}
    </Stack>
  );
};

export default FamilymemberDltWallet;

// import React, { useState, useEffect } from "react";
// import AreYouSureModal from "../../../../components/modals/areYouSureModal";
// import authServices from "../../../../services/authServices";
// import CustomIcon from "../../../../components/customIcon";
// import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
// import moment from "moment";
// import {
//     Button,
//     Card,
//     CardContent,
//     Divider,
//     Stack,
//     Typography,
//     Box,
//     Tabs,
//     Tab
// } from "@mui/material";
// import userServices from "../../../../services/userServices";
// import { useSnackbar } from "notistack";
// import familymemberServices from "../../../../services/familymemberServices";
// import FamilyMemberCreateDLTModel from "./FamilyCreateDLTModel";

// const FamilymemberDltWallet = ({ familyMemberId, getallFamilyMember }) => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [dltAccountId, setDltAccountId] = useState();
//     const [deleteOpen, setDeleteOpen] = useState(false);
//     const [primaryOpen, setPrimaryOpen] = useState(false);
//     const [availableBlockchainAccounts, setAvailableBlockchainAccounts] = useState([]);
//     const [blockchainAccountModal, setBlockchainAccountModal] = useState(false);
//     const [familymemberAccount, setFamilyMemberAccount] = useState();
//     const [selectedTab, setSelectedTab] = useState("ALG"); // ALG for Algorand, POL for Polygon

//     const { enqueueSnackbar } = useSnackbar();

//     const getFamilyMemberAccount = async () => {
//         const res = await familymemberServices.familyMemberById(familyMemberId);
//         if (res && res.success) {
//             setFamilyMemberAccount(res.data);
//         } else {
//             enqueueSnackbar("Something went wrong", { variant: "error", autoHideDuration: 4000 });
//         }
//     }

//     useEffect(() => {
//         getFamilyMemberAccount();
//     }, [blockchainAccountModal]);

//     const handlePrimary = async () => {
//         const res = await userServices.updatePrimaryDLTAccount({
//             entityType: "FAMILYMEMBER",
//             entityId: familyMemberId,
//             dltWalletId: dltAccountId,
//         });

//         if (res && res.success) {
//             getFamilyMemberAccount();
//         }
//     };

//     const handleRemove = async () => {
//         const res = await userServices.removeDLTAccount({
//             entityType: "FAMILYMEMBER",
//             entityId: familyMemberId,
//             dltWalletId: dltAccountId,
//         });
//         if (res && res.success) {
//             getFamilyMemberAccount();
//             enqueueSnackbar("DLT Account Deleted Successfully!", {
//                 variant: "success",
//                 autoHideDuration: 3000,
//             });
//         } else {
//             enqueueSnackbar(
//                 "This DLT Account is Holding Some Digital Assets. Please Contact RealX Admin!",
//                 { variant: "error", autoHideDuration: 9000 }
//             );
//         }
//     };

//     const fetchDltWallet = async () => {
//         let dltWallet = await userServices.getDltWallet(familyMemberId);
//         if(dltWallet?.data){
//             // Add dummy Polygon entry for now
//             const polygonWallet = dltWallet.data.map(acc => ({ ...acc, type: "POLYGON" }));
//             const combinedWallets = [
//                 ...dltWallet.data.map(acc => ({ ...acc, type: "ALG" })), 
//                 ...polygonWallet
//             ];
//             setAvailableBlockchainAccounts(combinedWallets);
//         }
//     };

//     useEffect(() => {
//         fetchDltWallet();
//     }, [familymemberAccount]);

//     const handleDLTCreationStatus = async (familyMemberId, status) => {
//         const res = await familymemberServices.updateFamilyMemberDLTCreationStatus({
//             familyMemberId: familyMemberId,
//             status,
//         });
//         if (res && res.success) {
//             getFamilyMemberAccount();
//         }
//     };

//     const copyUrl = (account) => {
//         navigator.clipboard.writeText(account);
//         enqueueSnackbar("Copied to Clipboard", { variant: "success", autoHideDuration: 800 });
//     };

//     const filteredAccounts = availableBlockchainAccounts.filter(acc =>
//         selectedTab === "ALG" ? acc.type === "ALG" : acc.type === "POLYGON"
//     );

//     return (
//         <Stack spacing={3} width={{ md: '100%', xs: '100%', lg: "50%", sm: "100%" }}>
//             <AreYouSureModal
//                 open={primaryOpen}
//                 setOpen={setPrimaryOpen}
//                 handleYes={handlePrimary}
//                 message={"Are You Sure About Updating your Primary DLT Account?"}
//                 publicAddress={filteredAccounts[currentIndex]?.publicAddress}
//                 publicAddressMessage={"Your New Primary DLT Account Address"}
//             />
//             <AreYouSureModal
//                 open={deleteOpen}
//                 setOpen={setDeleteOpen}
//                 handleYes={handleRemove}
//                 message={"Are You Sure About Permanently Deleting this DLT Account?"}
//                 note={"This action cannot be undone!"}
//                 publicAddress={filteredAccounts[currentIndex]?.publicAddress}
//                 publicAddressMessage={"DLT Account Address To Be Removed"}
//             />

//             <Typography fontSize={"14px"}>Available Blockchain Accounts</Typography>

//             {/* Tabs */}
//             <Tabs
//                 value={selectedTab}
//                 onChange={(e, newValue) => setSelectedTab(newValue)}
//                 sx={{ marginBottom: 2 }}
//             >
//                 <Tab label="Algorand" value="ALG" />
//                 <Tab label="Polygon" value="POL" />
//             </Tabs>

//             <Stack
//                 flexDirection={"column"}
//                 sx={{
//                     overflowX: { xs: "auto", sm: "auto", md: "hidden" },
//                     flexWrap: "wrap",
//                 }} gap={2}>
//                 {filteredAccounts.length > 0 ? (
//                     filteredAccounts
//                         .sort((a, b) => (b.isPrimary ? 1 : -1) - (a.isPrimary ? 1 : -1))
//                         .map((account, index) => (
//                             <Stack
//                                 key={`${account._id}-${account.type}`}
//                                 flexDirection={"row"}
//                                 columnGap={{ xs: 1, sm: 2 }}
//                                 sx={{ width: { lg: "100%", md: "65%", sm: "85%", xs: "min-content" } }}
//                             >
//                                 <Stack
//                                     flexDirection={"row"}
//                                     sx={{
//                                         padding: "15px",
//                                         borderRadius: "10px",
//                                         boxShadow: "0px 1px 6px 0px #51515129",
//                                         width: "100%",
//                                     }}
//                                 >
//                                     <Box sx={{ padding: "2px" }} width={"100%"}>
//                                         <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
//                                             <Typography sx={{ fontSize: "16px !important" }}>
//                                                 #{index + 1}. ...{account.publicAddress?.slice(-25)}
//                                             </Typography>
//                                             <Box
//                                                 onClick={(e) => { e.stopPropagation(); e.preventDefault(); copyUrl(account.publicAddress); }}
//                                                 sx={{
//                                                     bgcolor: "#f4f6f7",
//                                                     padding: "7px",
//                                                     borderRadius: "50%",
//                                                     marginLeft: "10px",
//                                                     height: "20px",
//                                                     width: "30px",
//                                                 }}
//                                             >
//                                                 <CustomIcon
//                                                     name="copy"
//                                                     sx={{ bgcolor: "#FFF", backgroundColor: "#333333", cursor: "pointer" }}
//                                                 />
//                                             </Box>
//                                             <Box sx={{ marginLeft: "4px" }}>
//                                                 {account.isPrimary ? (
//                                                     <Typography
//                                                         sx={{
//                                                             color: "white",
//                                                             background: "#21ab37",
//                                                             padding: "2px 15px !important",
//                                                             fontSize: "12px !important",
//                                                             border: "1px solid #21ab37",
//                                                             borderRadius: "10px",
//                                                         }}
//                                                     >
//                                                         Primary Account
//                                                     </Typography>
//                                                 ) : (
//                                                     <Stack flexDirection={"row"} alignItems={"center"} columnGap={{ xs: 1, sm: 2 }}>
//                                                         <Button
//                                                             variant="contained"
//                                                             sx={{ p: "4px 15px !important", fontSize: "12px !important" }}
//                                                             onClick={() => { setDltAccountId(account._id); setCurrentIndex(index); setPrimaryOpen(true); }}
//                                                         >
//                                                             Make Primary
//                                                         </Button>
//                                                         <RemoveCircleOutlineIcon
//                                                             sx={{ color: "red", cursor: "pointer" }}
//                                                             onClick={() => { setDltAccountId(account._id); setCurrentIndex(index); setDeleteOpen(true); }}
//                                                         />
//                                                     </Stack>
//                                                 )}
//                                             </Box>
//                                         </Box>

//                                         <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingTop: "10px" }}>
//                                             <Box>
//                                                 <Typography sx={{ fontWeight: "600", fontSize: "16px !important" }}>
//                                                     {account?.name?.slice(0, 30)}
//                                                 </Typography>
//                                             </Box>
//                                             <Box>
//                                                 <Typography sx={{ fontSize: "16px !important" }}>
//                                                     {account?.created_at ? `Created On: ${moment(account?.created_at).format("DD-MM-YYYY")}` : ""}
//                                                 </Typography>
//                                             </Box>
//                                         </Box>
//                                     </Box>
//                                 </Stack>
//                             </Stack>
//                         ))
//                 ) : (
//                     <Typography variant="subtitle1">You have not made any DLT accounts yet</Typography>
//                 )}
//             </Stack>

//             <Stack flexDirection={"row"} gap={1} justifyContent={'center'}>
//                 <Button
//                     onClick={() =>
//                         familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "APPROVED"
//                             ? setBlockchainAccountModal(true)
//                             : handleDLTCreationStatus(familymemberAccount?._id, "PENDING")
//                     }
//                     variant="contained"
//                     sx={{ width: "max-content", py: "10px !important" }}
//                     disabled={
//                         filteredAccounts?.length > 1 ||
//                         familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "PENDING" ||
//                         familymemberAccount?.status != "APPROVED"
//                     }>
//                     {familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "APPROVED"
//                         ? "Create a New DLT Account"
//                         : familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "PENDING"
//                             ? "Request Submitted to RealX Admin"
//                             : "Request to Create a New DLT Account"}
//                 </Button>

//                 {familymemberAccount?.walletInfo?.isAllowedToCreateDLT == "PENDING" && (
//                     <Button
//                         variant="contained"
//                         sx={{ py: "7px !important" }}
//                         onClick={() => handleDLTCreationStatus(familymemberAccount?._id, "CREATED")}>
//                         Cancel Request
//                     </Button>
//                 )}
//             </Stack>

//             {blockchainAccountModal && (
//                 <FamilyMemberCreateDLTModel
//                     open={blockchainAccountModal}
//                     setOpen={setBlockchainAccountModal}
//                     familymemberAccount={familymemberAccount}
//                     getallFamilyMember={() => getallFamilyMember()}
//                 />
//             )}
//         </Stack>
//     );
// };

// export default FamilymemberDltWallet;

